import { useLaunchDarklyTracker } from 'Client/LaunchDarklyTracker';
import { useSegmentTracking } from 'Common/segment';

export enum PLPToPDPMetricEventsMapping {
    p100IncreasedDesktopPageWidth = 'bella-plp-to-pdp-ABT34',
    p100PrlBoostIncrease = 'bella-plp-ctr-ABT47',
    p100PrlBoostDecrease = 'bella-plp-ctr-ABT47',
    p100ImageOnHoverPlp = 'bella-plp-to-pdp-ABT35',
    p100CategoryBubblesDisabledDesktop = 'bella-plp-to-pdp-ABT50',
}

const useListingPageTracking = () => {
    const launchDarklyTracker = useLaunchDarklyTracker();
    const { track } = useSegmentTracking();

    const trackPLPProductClicked = (relevantFeatureToggles: Record<string, boolean | undefined>) =>
        track('PLP Product Clicked', { ...relevantFeatureToggles });

    const trackPLPToPDP = (variation: keyof typeof PLPToPDPMetricEventsMapping) => {
        launchDarklyTracker.trackMetric(PLPToPDPMetricEventsMapping[variation]);
    };

    return {
        trackPLPToPDP,
        trackPLPProductClicked,
    };
};

export default useListingPageTracking;
